import { SecurityType } from '@orbis-systems/orbis-api-middleware';

export const getSecurityTypeName = (type: SecurityType): string => {
    switch (type) {
        case SecurityType.Equity:
            return 'Equity';
        case SecurityType.Option:
            return 'Option';
        case SecurityType.MutualFund:
            return 'Mutual Fund';
        case SecurityType.Bond:
            return 'Bond';
        case SecurityType.Etf:
            return 'ETF';
        case SecurityType.Algo:
            return 'Algo';
        default: {
            const exhaustiveCheck: never = type;
            return exhaustiveCheck;
        }
    }
};
